import App from './App'
import './styles/index.css'
import { store } from './store/store'
import { Provider } from 'react-redux'
import ReactDOM from 'react-dom/client'
import reportWebVitals from './reportWebVitals'
import { BrowserRouter } from 'react-router-dom'
import { restoreDjangoAuthFromStorage } from './services'

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement)

// Restaura token de Django si existe
restoreDjangoAuthFromStorage()

root.render(
  <BrowserRouter>
    {/* <StrictMode> */}
    <Provider store={store}>
      <App />
    </Provider>
    {/* </StrictMode> */}
  </BrowserRouter>
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
